import { useState, useEffect } from "react";
import Button from "../../Button/Button";
import Modal from "../Modal/Modal";
import PaymentCompleted from "../PaymentCompleted/PaymentCompleted";
import styles from "./PaymentSummaryModal.module.scss";
import { getTokenBalanceAction, redeemAssetAction, getUserWalletBalanceAction, } from "../../../../features/user/userSlice";
import { useDispatch } from "react-redux";
import { format } from "date-fns";
import { formatPrice } from "../../../../utils/utils";

const PaymentSummaryModal = ({
  handleClose, show, redeemData, paymentMode, resetForm, shippedFee, shippingFee,
}) => {
  const dispatch = useDispatch();
  const [showCompleted, setShowCompleted] = useState(false);
  const [productData, setProductData] = useState({});
  const [transactionId, setTransactionId] = useState("");
  const [loading, setLoading] = useState(false);

  const handleRedeemAsset = async () => {
    setLoading(true);
    try {
      const response = await dispatch(redeemAssetAction(productData));
      if (response.status === 200) {
        resetForm();
        setTransactionId(response.data.data.transactionId);
        const params = {
          tokenId: redeemData?.tokenId,
        };
        await dispatch(getTokenBalanceAction(params));
        await dispatch(getUserWalletBalanceAction());
        handleClose();
        setShowCompleted(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // const handleRedeemAsset = async () => {
  //   try {
  //     const response = await dispatch(redeemAssetAction(productData));
  //     if (response.status === 200) {
  //       resetForm();
  //       setTransactionId(response.data.data.transactionId);
  //       const params = {
  //         tokenId: redeemData?.tokenId,
  //       };
  //       await dispatch(getTokenBalanceAction(params));
  //       await dispatch(getUserWalletBalanceAction());
  //       handleClose();
  //       setShowCompleted(true);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const shipStation = async () => {
  //   try {
  //     const response = await dispatch(getShipstationCarriersAction());
  //     if (response.status === 200) {
  //       const carriers = response.data.data;
  //       console.log("1..............", response.data.data);
  //       setShipList(carriers);
  //       const carrierWithMaxBalance = carriers.reduce((maxCarrier, carrier) =>
  //         carrier.balance > maxCarrier.balance ? carrier : maxCarrier
  //       );
  //       console.log(
  //         "2....................................",
  //         carrierWithMaxBalance
  //       );
  //       setSelectedCarrier(carrierWithMaxBalance);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const shipStationRates = async () => {
  //   try {
  //     const response = await dispatch(
  //       getShipstationRatesAction({
  //         carrierCode: selectedCarrier?.code,
  //         fromPostalCode: 84003,
  //         toPostalCode: 84029,
  //         toState: "UT",
  //         toCity: "Grantsville",
  //         toCountry: "US",
  //         quantity: 8,
  //       })
  //     );
  //     if (response.status === 200) {
  //       setShipstationFee(response.data.data);
  //       const groundShipping = response.data.data?.find(
  //         (item) =>
  //           item.serviceName === "USPS Priority Mail - Medium Flat Rate Box"
  //       );
  //       console.log("3.............................", response.data.data);

  //       setShippedFee(groundShipping);
  //       console.log("4...................", groundShipping);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // name:Ohio
  // username:Ohiomint
  // email:anil1234@yopmail.com
  // city:Farmington
  // state:UT
  // postalCode:84025
  // country:US
  // phone:11111111111
  // address:467 E Island View Cir
  // quantity:3
  // price:30
  // carrierCode:ups
  // serviceCode:ups_ground

  useEffect(() => {
    let dataObj = {
      ...redeemData,
      fees: 0,
      shippingFees: redeemData?.totalAmount,
      // type: paymentMode?.toUpperCase(),
      type: "WIRE",
    };
    setProductData(dataObj);
  }, [redeemData, paymentMode]);

  // useEffect(() => {
  //   shipStation();
  // }, []);

  // useEffect(() => {
  //   if (selectedCarrier) {
  //     shipStationRates();
  //   }
  // }, [selectedCarrier]);

  return (
    <>
      <Modal
        show={show}
        handleClose={handleClose}
        title="Payment Summary"
        className={styles.payment_modal}
        backdropclass="payment_summary_backdrop"
      >
        <div className={styles.payment_modal_info}>
          <ul>
            <li>
              <h6>Quantity</h6>
              <h4>{redeemData?.quantity}</h4>
            </li>
            <li>
              <h6>Redeemed on</h6>
              <h4>{format(new Date(), "dd MMM, yyyy")}</h4>
            </li>
            <li>
              <h6>Pay with</h6>
              {/* <h4>{paymentMode} Wallet</h4> */}
              <h4>STBL Wallet</h4>
            </li>
            <li>
              <h6>Shipping Fees</h6>
              {/* <h4>{shippedFee?.shipmentCost}</h4> */}
              <h4>
                $
                {formatPrice(
                  Number(
                    shippedFee?.shipmentCost
                      ? redeemData?.totalAmount + shippedFee?.shipmentCost
                      : redeemData?.totalAmount
                  )
                )}
              </h4>
            </li>
            <li>
              <h6>Total</h6>
              <h4>
                $
                {formatPrice(
                  Number(
                    shippedFee?.shipmentCost
                      ? redeemData?.totalAmount + shippedFee?.shipmentCost
                      : redeemData?.totalAmount
                  )
                )}
              </h4>
            </li>
          </ul>
          <Button
            className={styles.confirm_btn}
            fluid
            // text="Confirm"
            text={loading ? "Processing..." : "Confirm"}
            onClick={() => {
              handleRedeemAsset();
            }}
            disabled={loading}
          />
        </div>
      </Modal>
      <PaymentCompleted
        show={showCompleted}
        txnId={transactionId}
        handleClose={() => setShowCompleted(false)}
        paymentType="REDEEM"
      />
    </>
  );
};

export default PaymentSummaryModal;
